import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	titleNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.three.title-non-final',
		defaultMessage: "What you'll leave behind in Opsgenie",
		description: 'Title of step three for optimal tooling wizard',
	},
	descriptionNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.three.description-non-final',
		defaultMessage:
			"A few legacy Opsgenie features that aren't supported by Jira Service Management will be left behind in Opsgenie. They'll keep working in Opsgenie until Opsgenie is turned off.",
		description: 'Description of step three for optimal tooling wizard',
	},
	integrationsInfoTitleNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.three.integrations-info-title-non-final',
		defaultMessage: '{count, plural, one {{count} integration} other {{count} integrations}}',
		description: 'Title of integrations section for optimal tooling wizard',
	},
	integrationsInfoDescriptionNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.three.integrations-info-description-non-final',
		defaultMessage:
			"{count} of your {totalCount, plural, one {{totalCount} Opsgenie integration} other {{totalCount} Opsgenie integrations}} won't be available in Jira Service Management. They'll still work in Opsgenie.",
		description: 'Description of integrations section for optimal tooling wizard',
	},
	teamsApiInfoTitleNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.three.teams-api-info-title-non-final',
		defaultMessage: 'Teams API in Opsgenie',
		description: 'Title of teams API section for optimal tooling wizard',
	},
	teamsApiInfoDescriptionNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.three.teams-api-info-description-non-final',
		defaultMessage:
			// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
			"Opsgenie's API for team management won't work anymore. It will have to be done through the alternative Jira Cloud Platform API.",
		description: 'Description of teams API section for optimal tooling wizard',
	},
	moreConfigurationsNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.three.more-configurations-non-final',
		defaultMessage: 'And a few more configurations:',
		description: 'More configurations section for optimal tooling wizard',
	},
	groupNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.three.group-non-final',
		defaultMessage: '{count, plural, one {{count} group} other {{count} groups}}',
		description: 'Group configuration for optimal tooling wizard',
	},
	heartbeatsNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.three.heartbeats-non-final',
		defaultMessage:
			'{count, plural, one {{count} global heartbeat} other {{count} global heartbeats}}',
		description: 'Heartbeat configuration for optimal tooling wizard',
	},
	notificationPoliciesNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.three.notification-policies-non-final',
		defaultMessage:
			'{count, plural, one {{count} global notification policy} other {{count} global notification policies}}',
		description: 'Notification policy configuration for optimal tooling wizard',
	},
	learnMoreNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.three.learn-more-non-final',
		defaultMessage: "Read more about what you'll leave behind in Opsgenie",
		description: 'Learn more link for optimal tooling wizard',
	},
});
